<template>
  <!-- https://buefy.org/documentation/field#addons -->
  <b-field class="form_field_filter">
    <p v-if="label" class="control">
      <span class="button is-skinny is-small is-static">{{ label }}</span>
    </p>

    <b-datepicker
      v-bind="$attrs"
      :class="classAttr"
      icon="calendar-today"
      size="is-small"
      :inline="isInline"
      expanded

      :value="date"
      :min-date="minDate"
      :max-date="maxDate"
      :range="isRange"

      locale="en-US"
      @input="handleInput"
    ></b-datepicker>
  </b-field>

</template>

<script>
  import FormField from "../../form/FormField";
  import {FormFieldMixin} from "../../form/FormField.mixin";

  export default {
    name: "FilterFieldDefault",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {
        type: [String, Number, Boolean, Date, Array],
      },
      label: {
        type: String
      },
      minDate: {
        type: Date
      },
      maxDate: {
        type: Date
      },
      isInline: {
        type: Boolean,
        default: false
      },
      isRange: {
        type: Boolean,
        default: false
      },
      classAttr: {
        type: String,
        default: ''
      },
      helpText: {
        type: String
      }
    },
    computed: {
      date() {
        if (this.value && ! this.isRange) {
          return new Date(this.value);
        }
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
// see form.scss
</style>
